import type { Directive, DirectiveBinding } from 'vue'

interface LongPressOptions {
    duration?: number // 长按时间，默认500ms
    callback: Function // 长按触发的回调函数
    params?: any[] // 回调函数的参数
}

interface HTMLElementWithLongPress extends HTMLElement {
    _longpressCleanup?: () => void
}

const longpress: Directive = {
    mounted(el: HTMLElementWithLongPress, binding: DirectiveBinding<LongPressOptions>) {
        if (typeof binding.value?.callback !== 'function') {
            console.warn('v-longpress 指令必须传入一个回调函数')
            return
        }

        let startTime: number = 0
        const duration = binding.value?.duration || 500

        const start = (e: TouchEvent) => {
            startTime = Date.now()
        }

        const end = (e: TouchEvent) => {
            if (startTime > 0) {
                const elapsed = Date.now() - startTime
                if (elapsed >= duration) {
                    binding.value.callback(...(binding.value.params || []))
                }
                startTime = 0
            }
        }

        const cancel = (e: TouchEvent) => {
            startTime = 0
        }

        el.addEventListener('touchstart', start)
        el.addEventListener('touchend', end)
        el.addEventListener('touchcancel', cancel)

        // 保存清理函数
        el._longpressCleanup = () => {
            el.removeEventListener('touchstart', start)
            el.removeEventListener('touchend', end)
            el.removeEventListener('touchcancel', cancel)
        }
    },

    unmounted(el: HTMLElementWithLongPress) {
        // 清理事件监听
        if (el._longpressCleanup) {
            el._longpressCleanup()
        }
    }
}

export default longpress 